/* Source: /home/sidsolaiyappan/skooch_ai/shared/sync_format.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
function formatSyncAgo(lastSyncIso, nowMs) {
  let _iso = ((lastSyncIso || "")).trim();
  if (!_iso) {
    return "";
  }
  let _parsed = Date.parse(_iso);
  if ((_parsed !== _parsed)) {
    return "";
  }
  let _diff = (nowMs - _parsed);
  if ((_diff < 0)) {
    _diff = 0;
  }
  if ((_diff < 60000)) {
    return "just now";
  }
  if ((_diff < 3600000)) {
    let _m = Math.floor((_diff / 60000));
    return (String(_m) + "m ago");
  }
  if ((_diff < 86400000)) {
    let _h = Math.floor((_diff / 3600000));
    return (String(_h) + "h ago");
  }
  let _d = Math.floor((_diff / 86400000));
  return (String(_d) + "d ago");
}
function gcalSyncLabelState(gcalStatus, syncing, nowMs) {
  if (syncing) {
    return "syncing";
  }
  let _status = "";
  let _last = "";
  try {
    _status = String(((gcalStatus ? gcalStatus.last_sync_status : "") || ""));
  } catch (__jac_e) {
    if (true) {
      let _es = __jac_e;
      _status = "";
    } else {
      throw __jac_e;
    }
  }
  try {
    _last = String(((gcalStatus ? gcalStatus.last_sync_at : "") || ""));
  } catch (__jac_e) {
    if (true) {
      let _el = __jac_e;
      _last = "";
    } else {
      throw __jac_e;
    }
  }
  if ((_status === "error")) {
    return "error";
  }
  if (formatSyncAgo(_last, nowMs)) {
    return "synced";
  }
  return "sync_now";
}
export {formatSyncAgo, gcalSyncLabelState};
//# sourceMappingURL=sync_format.js.map
